import type { ReduxAction, UserMetadata, UserMetadataFlag } from '@repo/utils/types';
import AppState from '../app-state';

export const initialDefaultReminderTime = { hour: 8, minute: 0 };

const initialUserMetadataState = {
  nexusCalloutDismissed: true,
  requestBirthdaysCalloutDismissed: true,
  accountProcessingToastDismissed: true,
  forceShowImportingContactsAlert: false,
  disableNoteReminderParsing: false,
  showNotesInSidebar: false,
  defaultReminderTime: initialDefaultReminderTime,
};

export const selectUserHasFlag = (flag: UserMetadataFlag) => (state: AppState) =>
  state.user.metadata[flag] === true;
export const selectDefaultReminderTime = (state: AppState) =>
  state.user.metadata?.defaultReminderTime || initialDefaultReminderTime;
export const selectUserMetadata = (state: AppState) => state.user.metadata;

export function userMetadataReducer(
  state: UserMetadata = initialUserMetadataState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_USER_METADATA_SUCCEEDED':
      return payload.response?.metadata;

    case 'UPDATE_USER_METADATA':
      return { ...state, ...payload };

    default:
      return state;
  }
}
